import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box } from '@mui/material'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import { useManageState } from './manageState'
import StateComponents from '../../../../components/state-component/StateComponents'
import { icons } from '../../../../assets/icons/icons'
import { debouncedApiCall } from '../../../../utils/app.utils'
import TableCustom from '../../../../components/table/tableCustom'
import { useNavigate } from 'react-router-dom'
import { library_history_status_data, library_payment_status_data } from '../../enum/elibrary_enum'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageOrders: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        path_name,
        set_search,
        handleChangeDateRange,
        end_date,
        start_date,
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        totalItems,
        data,
        library_payment_status,
        set_library_payment_status
    } = useManageState();
    return (
        <ContainerLayout
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "จัดการข้อมูล E-Library", // i18n-ignore
                            name: t("จัดการข้อมูล E-Library"),
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "จัดการรายการสั่งซื้อ", // i18n-ignore
                            name: t("จัดการรายการสั่งซื้อ"),
                            pathName: path_name
                        },
                    ]}
                />
            }
            title={t("จัดการรายการสั่งซื้อ")}
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                    startAdornment: <Box mr={1}> <icons.SearchNormal /></Box>,
                                    placeholder: t("ค้นหา ชื่อหนังสือ, ผู้ยืม")
                                }
                            },
                            {
                                seq: 2,
                                type: "DATE_RANGE2",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    handleChange: handleChangeDateRange,
                                    placeholder: t("ช่วงวันที่"),
                                    value: {
                                        end_date: end_date,
                                        start_date: start_date
                                    }
                                }
                            },
                            {
                                seq: 3,
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                },
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label ? t(op.label) : "",
                                    labelId: "library_history_status",
                                    placeholder: t("ทุกสถานะ"),
                                    onChange: (_, op) => set_library_payment_status(op ?? null),
                                    options: library_payment_status_data,
                                    value: library_payment_status
                                }
                            },
                        ]}
                    />


                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </Box>
            }
        />
    )
}

export default ManageOrders